import { Tooltip } from "antd";
import { Procedure } from "../../../../types/procedures";
import ProcedureCard from "./ProcedureCard";
import ProcedureMobileListItem from "./ProcedureMobileListItem";
import { useIsMobile } from "../../MobileBreakpointContext";
import { trackQuoteProcedureInfoOpened } from "../../../../utils/quoteAnalytics";
// @ts-ignore
import { useTranslation } from "react-i18next";

type ProcedureElementProps = {
  procedure: Procedure;
  isSelected: boolean;
  isDisabled: boolean;
  removeSelectedProcedure: (procedure: Procedure) => void;
  addSelectedProcedure: (procedure: Procedure) => void;
  imageUrl?: string;
  /** Opens the editorial ProcedureStory surface for this procedure. Replaces
   *  the three antd-info-modal setters (open/content/title) — the story reads
   *  everything it needs off the procedure object itself. */
  setStoryProcedure?: (procedure: Procedure) => void;
  selectedCount: number;
};

const ProcedureElement = ({
  procedure,
  isSelected,
  isDisabled,
  removeSelectedProcedure,
  addSelectedProcedure,
  imageUrl,
  setStoryProcedure,
  selectedCount,
}: ProcedureElementProps) => {
  // @ts-ignore
  const { t } = useTranslation("quote");
  const isMobile = useIsMobile();

  const onClickInfoCircle = (e: any) => {
    // Keep the ⓘ from toggling the card's selection — the icon sits inside the
    // card's own click target on both the desktop card and the mobile row.
    e?.stopPropagation();
    trackQuoteProcedureInfoOpened({
      procedureId: procedure.id,
      procedureTypeIds: (procedure.procedureTypes || []).map(
        (pt: any) => pt.id,
      ),
      surface: isMobile ? "mobile" : "desktop",
    });
    setStoryProcedure && setStoryProcedure(procedure);
  };

  const procedureCard = !isMobile ? (
    <div>
      <ProcedureCard
        isDisabled={isDisabled}
        procedure={procedure}
        isSelected={isSelected}
        removeSelectedProcedure={removeSelectedProcedure}
        addSelectedProcedure={addSelectedProcedure}
        onClickInfoCircle={onClickInfoCircle}
        imageUrl={imageUrl}
        selectedCount={selectedCount}
      />
    </div>
  ) : (
    <div>
      <ProcedureMobileListItem
        isDisabled={isDisabled}
        procedure={procedure}
        isSelected={isSelected}
        removeSelectedProcedure={removeSelectedProcedure}
        addSelectedProcedure={addSelectedProcedure}
        onClickInfoCircle={onClickInfoCircle}
        imageUrl={imageUrl}
        selectedCount={selectedCount}
      />
    </div>
  );

  return (
    <div>
      {isDisabled && (
        // trigger includes "click" so the incompatibility explanation is
        // reachable on touch — hover alone meant a mobile patient tapped a
        // greyed-out card and got nothing at all (2026-09-13 audit). The card's
        // own handlers still no-op while disabled.
        <Tooltip
          title={t("procedures.incompatibilityTooltip")}
          trigger={["hover", "click"]}
        >
          {procedureCard}
        </Tooltip>
      )}
      {!isDisabled && procedureCard}
    </div>
  );
};

export default ProcedureElement;
